import * as React from "react"
import TextField from "material-ui/TextField"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import strings from "../../localization/strings"
import ChipSelect from "../common/ChipSelect"
import Toggle from "material-ui/Toggle"
import autobind from "class-autobind"
import AccountStore from "../../stores/AccountStore"
import { EAccrualType, IAccrual } from "../../models"
import { guid } from "../../helpers/utils"
import * as api from "../../api"
import * as permissionHelper from "../../helpers/permissionHelper"
import ConfirmDialog from "../common/ConfirmDialog"
import _ from "lodash"
import * as utils from "../../helpers/utils"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"

interface IProps {
  existingAccruals: IAccrual[]
  editAccrual: IAccrual
  handleClose(): void
  handleAdd(accrual: IAccrual): void
  handleUpdate(accrual: IAccrual): void
}
interface IState {
  name: string
  code: string
  errorName: string
  contributingRatePerHour: string
  errorContributingRatePerHour: string
  contributingPayTypeIds: string[]
  errorContributingPayTypeIds: string
  allowUseForLeaveTracking: boolean
  requireNoteOnTimeOffApproval:boolean
  payTypeIdUsedForLeavePunchSet: string
  errorPayTypeIdUsedForLeavePunchSet: string
  deductionRatePerHour: string
  errorDeductionRatePerHour: string
  allowEdit: boolean
  confirmDialogAction: string
  confirmDialogContent: string
  confirmDialogPayload: any
  minBalance: string
  errorMinBalance: string
  maxBalance: string
  errorMaxBalance: string
  disableActionBtns: boolean
  accrualType: EAccrualType
}

export default class AddAccrual extends React.Component<IProps, IState> {
  private allowUseForLeaveTrackingAction = "allowUseForLeaveTrackingAction"
  private contributingPayTypeAction = "contributingPayTypeAction"
  private timeoffPunchSetPayTypeAction = "timeoffPunchSetPayTypeAction"
  constructor(props) {
    super(props)
    this.state = {
      name: this.props.editAccrual ? this.props.editAccrual.Name : "",
      code : this.props.editAccrual ? this.props.editAccrual.Code : "",
      errorName: "",
      contributingRatePerHour: this.props.editAccrual ? this.props.editAccrual.ContributingRatePerHour.toString() : "0.01",
      errorContributingRatePerHour: "",
      contributingPayTypeIds: this.props.editAccrual ? this.props.editAccrual.ContributingPayTypeIds : [],
      errorContributingPayTypeIds: "",
      allowUseForLeaveTracking: this.props.editAccrual ? this.props.editAccrual.AllowUseForLeaveTracking : false,
      requireNoteOnTimeOffApproval: this.props.editAccrual ? this.props.editAccrual.RequireNoteOnTimeOffApproval : false,
      payTypeIdUsedForLeavePunchSet: this.props.editAccrual ? this.props.editAccrual.PayTypeIdUsedForLeavePunchSet : "",
      errorPayTypeIdUsedForLeavePunchSet: "",
      deductionRatePerHour: this.props.editAccrual ? this.props.editAccrual.DeductionRatePerHour.toString() : "-1",
      errorDeductionRatePerHour: "",
      allowEdit: this.props.editAccrual ? false : true,
      confirmDialogAction: "",
      confirmDialogContent: "",
      confirmDialogPayload: null,
      minBalance: this.props.editAccrual ? this.props.editAccrual.MinBalance.toString() : "0",
      errorMinBalance: "",
      maxBalance: this.props.editAccrual && this.props.editAccrual.MaxBalance ? this.props.editAccrual.MaxBalance.toString() : "",
      errorMaxBalance: "",
      disableActionBtns: false,
      accrualType: this.props.editAccrual ? this.props.editAccrual.Type : EAccrualType.PerHourWorked
    }
    autobind(this)
  }

  componentDidMount() {
    this.props.editAccrual && this.getAllowChangeAccrual()
  }

  getAllowChangeAccrual() {
    api.getAllowChangeAccAccrual(AccountStore.getCurrentAccount().Id, this.props.editAccrual.Id).then(res => {
      this.setState({ allowEdit: res.data })
    })
  }

  handleSave() {
    this.setState({ disableActionBtns: true }, () =>
      this.checkValidate().then(res => {
        if (res) {
          const accrual: IAccrual = {
            Id: this.props.editAccrual ? this.props.editAccrual.Id : guid(),
            Name: this.state.name,
            Code: this.state.code,
            ContributingRatePerHour: Number(this.state.contributingRatePerHour),
            ContributingPayTypeIds: this.state.accrualType === EAccrualType.PerHourWorked ? this.state.contributingPayTypeIds : [],
            AllowUseForLeaveTracking: this.state.allowUseForLeaveTracking,
            RequireNoteOnTimeOffApproval: this.state.requireNoteOnTimeOffApproval,
            DeductionRatePerHour: this.state.allowUseForLeaveTracking ? Number(this.state.deductionRatePerHour) : -1,
            PayTypeIdUsedForLeavePunchSet: this.state.allowUseForLeaveTracking ? this.state.payTypeIdUsedForLeavePunchSet : "",
            AccountId: AccountStore.getCurrentAccount().Id,
            MinBalance: Number(this.state.minBalance),
            MaxBalance: this.state.maxBalance && Number(this.state.maxBalance),
            Deleted: false,
            Type: this.state.accrualType
          }
          this.props.editAccrual ? this.props.handleUpdate(accrual) : this.props.handleAdd(accrual)
        }
        else {
          this.setState({ disableActionBtns: false })
        }
      })
    )
  }

  checkValidate() {
    let isValidate = true
    if (this.state.name.trim().length === 0) {
      this.setState({ errorName: strings.NameRequired })
      isValidate = false
    }
    else if (this.props.existingAccruals.filter((accrual) => this.props.editAccrual ? accrual.Id !== this.props.editAccrual.Id : true).find((existingAccrual) => existingAccrual.Name === this.state.name.trim())) {
      this.setState({ errorName: strings.Accrual_name_is_duplicated })
      isValidate = false
    }
    else {
      this.setState({ errorName: "" })
    }

    if (!this.state.contributingRatePerHour.trim()) {
      this.setState({ errorContributingRatePerHour: strings.This_field_is_required })
      isValidate = false
    }
    else if (Number.isNaN(Number(this.state.contributingRatePerHour))) {
      this.setState({ errorContributingRatePerHour: strings.Invalid_format })
      isValidate = false
    }
    else if (Number(this.state.contributingRatePerHour) < 0) {
      this.setState({ errorContributingRatePerHour: strings.This_field_must_be_greater_than_or_equal_to_zero })
      isValidate = false
    }
    else {
      this.setState({ errorContributingRatePerHour: "" })
    }

    if (this.state.accrualType === EAccrualType.PerHourWorked) {
      if (this.state.contributingPayTypeIds.length === 0) {
        this.setState({ errorContributingPayTypeIds: strings.This_field_is_required })
        isValidate = false
      }
      else {
        this.setState({ errorContributingPayTypeIds: "" })
      }
    }

    if (!this.state.minBalance.trim()) {
      this.setState({ errorMinBalance: strings.This_field_is_required })
      isValidate = false
    }
    else if (Number.isNaN(Number(this.state.minBalance))) {
      this.setState({ errorMinBalance: strings.Invalid_format })
      isValidate = false
    }
    else if (Number(this.state.minBalance) > 0) {
      this.setState({ errorMinBalance: strings.formatString(strings.This_field_must_be_less_than_or_equal_to_x, 0) as string })
      isValidate = false
    }
    else if (Number(this.state.minBalance) < -10000) {
      this.setState({ errorMinBalance: strings.formatString(strings.This_field_must_be_greater_than_or_equal_to_x, -10000) as string })
      isValidate = false
    }
    else {
      this.setState({ errorMinBalance: "" })
    }

    if (this.state.maxBalance.trim() && Number.isNaN(Number(this.state.maxBalance))) {
      this.setState({ errorMaxBalance: strings.Invalid_format })
      isValidate = false
    }
    else if (this.state.maxBalance.trim() && Number(this.state.maxBalance) < -10000) {
      this.setState({ errorMaxBalance: strings.formatString(strings.This_field_must_be_greater_than_or_equal_to_x, -10000) as string })
      isValidate = false
    }
    else if (this.state.maxBalance.trim() && Number(this.state.maxBalance) > 10000) {
      this.setState({ errorMaxBalance: strings.formatString(strings.This_field_must_be_less_than_or_equal_to_x, 10000) as string })
      isValidate = false
    }
    else {
      this.setState({ errorMaxBalance: "" })
    }

    if (this.state.allowUseForLeaveTracking) {
      if (!this.state.payTypeIdUsedForLeavePunchSet) {
        this.setState({ errorPayTypeIdUsedForLeavePunchSet: strings.This_field_is_required })
        isValidate = false
      }
      else {
        this.setState({ errorPayTypeIdUsedForLeavePunchSet: "" })
      }

      if (!this.state.deductionRatePerHour.trim()) {
        this.setState({ errorDeductionRatePerHour: strings.This_field_is_required })
        isValidate = false
      }
      else if (Number.isNaN(Number(this.state.deductionRatePerHour))) {
        this.setState({ errorDeductionRatePerHour: strings.Invalid_format })
        isValidate = false
      }
      else if (Number(this.state.deductionRatePerHour) >= 0) {
        this.setState({ errorDeductionRatePerHour: strings.formatString(strings.This_field_must_be_less_than_x, 0) as string })
        isValidate = false
      }
      else {
        this.setState({ errorDeductionRatePerHour: "" })
      }
    }
    return new Promise(resolve => {
      if (this.props.editAccrual) {
        if (!isValidate) {
          resolve(false)
        }
        else {
          const accountId = AccountStore.getCurrentAccount().Id
          api.CheckValidateAccountAccrualPayTypes(accountId, this.props.editAccrual.Id, this.state.contributingPayTypeIds).then(res => {
            if (res.data) {
              if (this.state.allowUseForLeaveTracking) {
                api.CheckValidateAccountAccrualPayTypes(accountId, this.props.editAccrual.Id, [this.state.payTypeIdUsedForLeavePunchSet]).then(res1 => {
                  if (res1.data) {
                    resolve(true)
                  }
                  else {
                    this.setState({ errorPayTypeIdUsedForLeavePunchSet: strings.Its_not_valid_for_pay_group_used_employee })
                    resolve(false)
                  }
                })
              }
              else {
                resolve(true)
              }
            }
            else {
              this.setState({ errorContributingPayTypeIds: strings.Its_not_valid_for_pay_group_used_employee })
              resolve(false)
            }
          })
        }
      }
      else {
        resolve(isValidate)
      }
    })
  }

  addContributingPayTypes(obj) {
    if (!obj) return
    const contributingPayTypeIds = _.cloneDeep(this.state.contributingPayTypeIds)
    contributingPayTypeIds.push(obj.Id)
    this.handleChangePayTypeActions(this.contributingPayTypeAction, this.state.payTypeIdUsedForLeavePunchSet, contributingPayTypeIds)
  }

  removeContributingPayTypes(obj) {
    const contributingPayTypeIds = _.cloneDeep(this.state.contributingPayTypeIds)
    const indexOf = contributingPayTypeIds.indexOf(obj.Id)
    if (indexOf > -1) {
      contributingPayTypeIds.splice(indexOf, 1)
      this.handleChangePayTypeActions(this.contributingPayTypeAction, this.state.payTypeIdUsedForLeavePunchSet, contributingPayTypeIds)
    }
  }

  handleConfirm(action, payload) {
    if (action === this.allowUseForLeaveTrackingAction) {
      this.setState({ allowUseForLeaveTracking: payload })
    }
    else if (action === this.contributingPayTypeAction) {
      this.setState({ contributingPayTypeIds: payload, }, () =>
        this.checkValidate()
      )
    }
    else if (action === this.timeoffPunchSetPayTypeAction) {
      this.setState({ payTypeIdUsedForLeavePunchSet: payload }, () =>
        this.checkValidate()
      )
    }

    this.setState({ confirmDialogAction: "", confirmDialogContent: "", confirmDialogPayload: null })
  }

  handleChangePayTypeActions(action, payTypeIdUsedForLeavePunchSet: string, contributingPayTypeIds: string[]) {
    if (
      payTypeIdUsedForLeavePunchSet &&
      contributingPayTypeIds.length > 0 &&
      contributingPayTypeIds.includes(payTypeIdUsedForLeavePunchSet)
    ) {
      const payTypeName = payGroupAndTypeHelper.getPayTypeNameById(payTypeIdUsedForLeavePunchSet)
      this.setState({
        confirmDialogAction: action,
        confirmDialogPayload: action === this.contributingPayTypeAction ? contributingPayTypeIds : payTypeIdUsedForLeavePunchSet,
        confirmDialogContent: strings.formatString(strings.x_pay_type_is_used_for_the_leave_punch_set_are_you_sure_you_want_to_also_have_it_contribute_to_the_accrual, payTypeName) as string
      })
    }
    else {
      this.setState({
        payTypeIdUsedForLeavePunchSet,
        contributingPayTypeIds
      }, () => this.checkValidate())
    }
  }

  render() {
    return (
      <Dialog
        open
        title={this.props.editAccrual ? `${strings.Edit_Accrual} - ${this.props.editAccrual.Name}` : strings.Add_Accrual}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        autoScrollBodyContent
        actions={
          <div>
            <FlatButton
              data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Btn-CloseAddAccrualDialog"}
              label={strings.CANCEL}
              secondary
              onTouchTap={this.props.handleClose}
            />
            <FlatButton
              data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Btn-SaveAccrual"}
              label={strings.SAVE}
              primary
              disabled={this.state.disableActionBtns}
              onTouchTap={this.handleSave}
            />
          </div>
        }
      >
        <hr />
        <div style={{ paddingLeft: 15, paddingRight: 15 }}>
            <div style={{display:"flex"}}>
          <TextField
            data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Entry-Name"}
            floatingLabelText={strings.Name}
            value={this.state.name}
            style={{ width: 250}}
            
            onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
            errorText={this.state.errorName}
            errorStyle={{ position: "absolute", bottom: -10 }}
          />
           <TextField
            data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Entry-Name"}
            floatingLabelText={strings.Code}
            value={this.state.code}
            style={{ width: 250,marginLeft:100  }}
            onChange={(e, value) => { this.setState({ code: value }, () => this.checkValidate()) }}
            
            errorStyle={{ position: "absolute", bottom: -10 }}
          />
          </div>
          <SelectField
            data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Select-AccrualType"}
            style={{ width: 275 }}
            floatingLabelText={strings.Accrual_Type}
            value={this.state.accrualType}
            disabled={this.props.editAccrual ? true : false}
            onChange={(e, key, payload) => this.setState({ accrualType: payload }, () => this.checkValidate())}
          >
            <MenuItem value={EAccrualType.PerHourWorked} primaryText={strings.Per_Hour_Worked} />
            <MenuItem value={EAccrualType.PerDay} primaryText={strings.Per_Day} />
            <MenuItem value={EAccrualType.Monetary} primaryText={"Monetary"} />
          </SelectField>
          <div style={{ display: "flex" }}>
          {this.state.accrualType !== EAccrualType.Monetary &&
              <TextField
                data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Entry-AccrualRatePerHour"}
                floatingLabelText={this.state.accrualType === EAccrualType.PerHourWorked ? strings.Accrual_Rate_Per_Hour : strings.Accrual_Rate_Per_Day}
                value={this.state.contributingRatePerHour}
                style={{ width: 250 }}
                onChange={(e, value) => {
                  // limit 5 decimal
                  if (!Number.isNaN(Number(value)) && utils.decimalCount(Number(value)) > 5)
                    return
                  this.setState({ contributingRatePerHour: value }, () => this.checkValidate())
                }}
                errorText={this.state.errorContributingRatePerHour}
                errorStyle={{ position: "absolute", bottom: -10 }}
              />
            }
            {this.state.accrualType === EAccrualType.PerHourWorked &&
              <div style={{ marginLeft: 100, marginTop: 10 }}>
                <ChipSelect
                  title={strings.Pay_Types_Contributing_To_Accrual}
                  titleStyle={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}
                  allData={AccountStore.getCurrentAccount().PayTypes}
                  linkedData={AccountStore.getCurrentAccount().PayTypes.filter(accItem => this.state.contributingPayTypeIds.find(item => item === accItem.Id))}
                  chipStyle={{ marginTop: 10, marginRight: 5, height: 35 }}
                  addButtonStyle={{ height: 33, marginTop: 2, display: "inline-block" }}
                  labelTextForSelect={strings.Select_Pay_Type}
                  handleAddOne={this.addContributingPayTypes}
                  handleDeleteOne={this.removeContributingPayTypes}
                  errorText={this.state.errorContributingPayTypeIds}
                />
              </div>
            }
          </div>
          {this.state.accrualType !== EAccrualType.Monetary &&
            <div >
              <TextField
                data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Entry-MinBalance"}
                floatingLabelText={strings.Min_Balance}
                value={this.state.minBalance}
                style={{ width: 250 }}
                onChange={(e, value) => { this.setState({ minBalance: value }, () => this.checkValidate()) }}
                errorText={this.state.errorMinBalance}
                errorStyle={{ position: "absolute", top: 65 }}
              />
              <TextField
                data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Entry-MaxBalance"}
                floatingLabelText={strings.Max_Balance}
                value={this.state.maxBalance}
                style={{ width: 250, marginLeft: 100 }}
                onChange={(e, value) => { this.setState({ maxBalance: value }, () => this.checkValidate()) }}
                errorText={this.state.errorMaxBalance}
                errorStyle={{ position: "absolute", top: 65 }}
              />
            </div>
          }
          {this.state.accrualType !== EAccrualType.Monetary &&
          <div style={{display:"flex", width:"90%",marginTop: 40,justifyContent:"space-between" }}>
            <div style={{ width: "45%", }}>
              <Toggle
                data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Toggle-AllowAccrualForLeaveTracking"}
                toggled={this.state.allowUseForLeaveTracking}
                label={strings.Allow_Accrual_For_Leave_Tracking}
                onToggle={(e, value) => {
                  this.state.allowEdit ?
                    this.setState({ allowUseForLeaveTracking: value }) :
                    this.setState({
                      confirmDialogAction: this.allowUseForLeaveTrackingAction,
                      confirmDialogPayload: value,
                      confirmDialogContent: strings.Are_you_sure_you_want_to_change_this_value_as_Global_Admin
                    })
                }}
                disabled={!this.state.allowEdit && !permissionHelper.isGlobalAdmin()}
              />
            </div>
            {this.state.allowUseForLeaveTracking && <div style={{ width: "45%" }}>
              <Toggle
                data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Toggle-RequireNoteonTimeOffApproval"}
                toggled={this.state.requireNoteOnTimeOffApproval}
                label={strings.Require_Note_On_Time_Off_Approval}
                onToggle={(e, value) => {
                 
                    this.setState({ requireNoteOnTimeOffApproval: value }) 
                    
                }}
                disabled={!this.state.allowEdit && !permissionHelper.isGlobalAdmin()}
              />
            </div>}
            </div>
          }
          {this.state.allowUseForLeaveTracking &&
            <div style={{ marginTop: 10, display: "flex" }} >
              <SelectField
                data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Select-PayTypeUsedForLeavePunchSet"}
                style={{ width: 275 }}
                floatingLabelText={strings.Pay_Type_Used_for_Leave_Punch_Set}
                value={this.state.payTypeIdUsedForLeavePunchSet}
                onChange={(e, key, payload) =>
                  this.handleChangePayTypeActions(this.timeoffPunchSetPayTypeAction, payload, this.state.contributingPayTypeIds)
                }
                errorText={this.state.errorPayTypeIdUsedForLeavePunchSet}
                errorStyle={{ position: "absolute", top: 70 }}
              >
                {AccountStore.getCurrentAccount().PayTypes.filter(item => item.CreditAccrual).map((payType, key) =>
                  <MenuItem key={key} value={payType.Id} primaryText={payType.Name} />
                )}
              </SelectField>
              <TextField
                data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab-Add-Entry-DeductionRatePerHourForLeave"}
                floatingLabelText={strings.Deduction_Rate_Per_Hour_for_Leave}
                value={this.state.deductionRatePerHour}
                onChange={(e, value) => this.setState({ deductionRatePerHour: value }, () => this.checkValidate())}
                style={{ width: 290, marginLeft: 90 }}
                floatingLabelStyle={{ width: 385 }}
                errorText={this.state.errorDeductionRatePerHour}
                errorStyle={{ position: "absolute", bottom: -12 }}
              />
            </div>
          }
        </div>
        {this.state.confirmDialogContent &&
          <ConfirmDialog
            open
            action={this.state.confirmDialogAction}
            confirmContent={this.state.confirmDialogContent}
            payload={this.state.confirmDialogPayload}
            close={() => this.setState({ confirmDialogAction: "", confirmDialogContent: "", confirmDialogPayload: null })}
            confirm={this.handleConfirm}
          />
        }
      </Dialog>
    )
  }
}